import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { store } from './config/store'
import reportWebVitals from './reportWebVitals'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

import theme from './theme'
import { GlobalStyles } from '@mui/material'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <GlobalStyles
        styles={{
          '*::-webkit-scrollbar': {
            width: '0.4em',
            height: '0.2em',
            backgroundColor: '#F4F4F4',
          },
          '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#E48B8B',
            borderRadius: '10px',
            // outline: '1px solid slategrey',
          },
          '*::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#CF2A2A',
            borderRadius: '10px',
            // outline: '1px solid slategrey',
          },
          html: {
            fontSize: '10px',
          },
        }}
      />
      {/* <GlobalStyles styles={{ ...darkScrollbar() }} /> */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
